/** @format */

// eslint-disable-next-line no-shadow
export enum ProductPageTemplateType {
	BUNDLE = 'Bundle',
	OUT_OF_STOCK = 'OutOfStock',
	STANDARD = 'Standard'
}
